
import { useQuery } from "@tanstack/react-query";
import { recipeService } from "@/services/recipe";
import { recipeStatsService, RecipeWithStats } from "@/services/recipe/recipeStatsService";

export const useRecipeStats = () => {
  return useQuery({
    queryKey: ['recipes-with-stats'],
    queryFn: async (): Promise<RecipeWithStats[]> => {
      const recipes = await recipeService.getRecipes();
      return await recipeStatsService.getRecipesWithStats(recipes);
    },
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false,
    retry: 1,
  });
};
